<template>
  <div v-if="isLoading" style="display: block">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="stella-pulse-spinner">
              <div class="stella-pulse-dot"></div>
              <div class="stella-pulse-dot"></div>
              <div class="stella-pulse-dot"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "LoadingModal",
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(5, 5, 8, 0.65);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity .25s ease;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: rgba(20, 20, 26, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.5), 0 0 20px rgba(229, 59, 185, 0.2);
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all .25s ease;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}

.stella-pulse-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.stella-pulse-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #E53BB9;
  animation: stellaPulseDot 0.8s infinite cubic-bezier(.2,.68,.18,1.08);
}

.stella-pulse-dot:nth-child(1) { animation-delay: 0.12s; }
.stella-pulse-dot:nth-child(2) { animation-delay: 0.24s; }
.stella-pulse-dot:nth-child(3) { animation-delay: 0.36s; }

@keyframes stellaPulseDot {
  0%, 100% {
    transform: scale(0.65);
    opacity: 0.35;
  }
  50% {
    transform: scale(1.15);
    opacity: 1;
    box-shadow: 0 0 12px rgba(229, 59, 185, 0.85);
  }
}
</style>

